"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultToolbarStyles = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _CloudDownload = _interopRequireDefault(require("@material-ui/icons/CloudDownload"));
var _Print = _interopRequireDefault(require("@material-ui/icons/Print"));
var _ViewColumn = _interopRequireDefault(require("@material-ui/icons/ViewColumn"));
var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));
var _reactToPrint = _interopRequireDefault(require("react-to-print"));
var _lodash = _interopRequireDefault(require("lodash.find"));
var _styles = require("@material-ui/core/styles");
var _lodash2 = _interopRequireDefault(require("lodash.clonedeep"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _utils = require("../utils");
var _TableSearch = _interopRequireDefault(require("./TableSearch"));
var _TableViewCol = _interopRequireDefault(require("./TableViewCol"));
var _TableFilter = _interopRequireDefault(require("./TableFilter"));
var _Popover = _interopRequireDefault(require("./Popover"));
var _util = require("@bento-core/util");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultToolbarStyles = function defaultToolbarStyles(theme) {
  var _ref;
  return _ref = {
    root: {
      backgroundColor: 'white !important',
      '@media print': {
        display: 'none'
      }
    },
    tableToolbar: {
      backgroundColor: 'white !important',
      paddingTop: '1em'
    },
    dalTooltip: {
      padding: '0px 12px !important'
    },
    dalPopper: {
      left: '-278px !important'
    },
    fullWidthRoot: {
      backgroundColor: 'white !important'
    },
    left: {
      flex: '1 1 auto'
    },
    fullWidthLeft: {
      flex: '1 1 auto'
    },
    actions: {
      flex: '1 1 auto',
      textAlign: 'right'
    },
    fullWidthActions: {
      flex: '1 1 auto',
      textAlign: 'right'
    },
    titleRoot: {},
    titleText: {},
    fullWidthTitleText: {
      textAlign: 'left'
    },
    icon: {
      '&:hover': {
        color: theme.palette.primary.main
      }
    },
    iconActive: {
      color: theme.palette.primary.main
    },
    filterPaper: {
      maxWidth: '50%'
    },
    filterCloseIcon: {
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 100
    },
    searchIcon: {
      display: 'inline-flex',
      marginTop: '10px',
      marginRight: '8px'
    }
  }, _defineProperty2(_ref, theme.breakpoints.down('sm'), {
    titleRoot: {},
    titleText: {
      fontSize: '16px'
    },
    spacer: {
      display: 'none'
    },
    left: {
      // flex: "1 1 40%",
      padding: '8px 0px'
    },
    actions: {
      // flex: "1 1 60%",
      textAlign: 'right'
    }
  }), _defineProperty2(_ref, theme.breakpoints.down('xs'), {
    root: {
      display: 'block',
      '@media print': {
        display: 'none !important'
      }
    },
    left: {
      padding: '8px 0px 0px 0px'
    },
    titleText: {
      textAlign: 'center'
    },
    actions: {
      textAlign: 'center'
    }
  }), _defineProperty2(_ref, '@media screen and (max-width: 480px)', {}), _ref;
};
exports.defaultToolbarStyles = defaultToolbarStyles;
var RESPONSIVE_FULL_WIDTH_NAME = 'scrollFullHeightFullWidth';
var TableToolbar = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableToolbar, _react$default$Compon);
  function TableToolbar() {
    var _this;
    _classCallCheck(this, TableToolbar);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableToolbar).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      iconActive: null,
      showSearch: Boolean(_this.props.searchText || _this.props.options.searchText || _this.props.options.searchOpen),
      searchText: _this.props.searchText || null
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCSVDownload", function () {
      var _this$props = _this.props,
        data = _this$props.data,
        displayData = _this$props.displayData,
        columns = _this$props.columns,
        options = _this$props.options;
      var dataToDownload = (0, _lodash2.default)(data);
      var columnsToDownload = columns;
      if (options.downloadOptions && options.downloadOptions.filterOptions) {
        // check rows first:
        if (options.downloadOptions.filterOptions.useDisplayedRowsOnly) {
          dataToDownload = displayData.map(function (row, index) {
            var i = -1;

            // Help to preserve sort order in custom render columns
            row.index = index;
            return {
              data: row.data.map(function (column) {
                i += 1;

                // if we have a custom render, which will appear as a react element, we must grab the actual value from data
                // that matches the dataIndex and column
                // TODO: Create a utility function for checking whether or not something is a react object
                return typeof column === 'object' && column !== null && !Array.isArray(column) ? (0, _lodash.default)(data, function (d) {
                  return d.index === row.dataIndex;
                }).data[i] : column;
              })
            };
          });
        }

        // now, check columns:
        if (options.downloadOptions.filterOptions.useDisplayedColumnsOnly) {
          columnsToDownload = columns.filter(function (_) {
            return _.display === 'true';
          });
          dataToDownload = dataToDownload.map(function (row) {
            row.data = row.data.filter(function (_, index) {
              return columns[index].display === 'true';
            });
            return row;
          });
        }
      }
      (0, _utils.createCSVDownload)(columnsToDownload, dataToDownload, options, _utils.downloadCSV);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setActiveIcon", function (iconName) {
      _this.setState(function (prevState) {
        return {
          showSearch: _this.isSearchShown(iconName),
          iconActive: iconName,
          prevIconActive: prevState.iconActive
        };
      }, function () {
        var _this$state = _this.state,
          iconActive = _this$state.iconActive,
          prevIconActive = _this$state.prevIconActive;
        if (iconActive === 'filter') {
          _this.props.setTableAction('onFilterDialogOpen');
          if (_this.props.options.onFilterDialogOpen) {
            _this.props.options.onFilterDialogOpen();
          }
        }
        if (iconActive === undefined && prevIconActive === 'filter') {
          _this.props.setTableAction('onFilterDialogClose');
          if (_this.props.options.onFilterDialogClose) {
            _this.props.options.onFilterDialogClose();
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isSearchShown", function (iconName) {
      var nextVal = false;
      if (_this.state.showSearch) {
        if (_this.state.searchText) {
          nextVal = true;
        } else {
          var onSearchClose = _this.props.options.onSearchClose;
          _this.props.setTableAction('onSearchClose');
          if (onSearchClose) onSearchClose();
          nextVal = false;
        }
      } else if (iconName === 'search') {
        nextVal = _this.showSearch();
      }
      return nextVal;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveIcon", function (styles, iconName) {
      var isActive = _this.state.iconActive === iconName;
      if (iconName === 'search') {
        var _this$state2 = _this.state,
          showSearch = _this$state2.showSearch,
          searchText = _this$state2.searchText;
        isActive = isActive || showSearch || searchText;
      }
      return isActive ? styles.iconActive : styles.icon;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showSearch", function () {
      _this.props.setTableAction('onSearchOpen');
      !!_this.props.options.onSearchOpen && _this.props.options.onSearchOpen();
      return true;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideSearch", function () {
      var onSearchClose = _this.props.options.onSearchClose;
      _this.props.setTableAction('onSearchClose');
      if (onSearchClose) onSearchClose();
      _this.props.searchClose();
      _this.setState(function () {
        return {
          iconActive: null,
          showSearch: false,
          searchText: null
        };
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearch", function (value) {
      _this.setState({
        searchText: value
      });
      _this.props.searchTextUpdate(value);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchIconClick", function () {
      var _this$state3 = _this.state,
        showSearch = _this$state3.showSearch,
        searchText = _this$state3.searchText;
      if (showSearch && !searchText) {
        _this.hideSearch();
      } else {
        _this.setActiveIcon('search');
      }
    });
    return _this;
  }
  _createClass(TableToolbar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.searchText !== prevProps.searchText) {
        this.setState({
          searchText: this.props.searchText
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        data = _this$props2.data,
        options = _this$props2.options,
        classes = _this$props2.classes,
        columns = _this$props2.columns,
        filterData = _this$props2.filterData,
        filterList = _this$props2.filterList,
        filterUpdate = _this$props2.filterUpdate,
        resetFilters = _this$props2.resetFilters,
        toggleViewColumn = _this$props2.toggleViewColumn,
        title = _this$props2.title,
        _this$props2$componen = _this$props2.components,
        components = _this$props2$componen === void 0 ? {} : _this$props2$componen,
        updateFilterByType = _this$props2.updateFilterByType;
      var Tooltip = components.Tooltip || _Tooltip.default;
      var _options$textLabels$t = options.textLabels.toolbar,
        search = _options$textLabels$t.search,
        downloadCsv = _options$textLabels$t.downloadCsv,
        print = _options$textLabels$t.print,
        viewColumns = _options$textLabels$t.viewColumns,
        filterTable = _options$textLabels$t.filterTable;
      var _this$state4 = this.state,
        showSearch = _this$state4.showSearch,
        searchText = _this$state4.searchText;
      var filterPopoverExit = function filterPopoverExit() {
        _this2.setState({
          hideFilterPopover: false
        });
        _this2.setActiveIcon.bind(null);
      };
      var closeFilterPopover = function closeFilterPopover() {
        _this2.setState({
          hideFilterPopover: true
        });
      };
      return /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
        className: options.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? classes.root : classes.fullWidthRoot,
        role: "toolbar",
        "aria-label": "Table Toolbar",
        classes: {
          root: classes.tableToolbar
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: options.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? classes.left : classes.fullWidthLeft
      }, showSearch === true ? options.customSearchRender ? options.customSearchRender(searchText, this.handleSearch, this.hideSearch, options) : /*#__PURE__*/_react.default.createElement(_TableSearch.default, {
        searchText: searchText,
        onSearch: this.handleSearch,
        onHide: this.hideSearch,
        options: options
      }) : typeof title !== 'string' ? title : /*#__PURE__*/_react.default.createElement("div", {
        className: classes.titleRoot,
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "h6",
        className: options.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? classes.titleText : classes.fullWidthTitleText
      }, title))), /*#__PURE__*/_react.default.createElement("div", {
        className: options.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? classes.actions : classes.fullWidthActions
      }, options.search && /*#__PURE__*/_react.default.createElement(Tooltip, {
        title: search,
        disableFocusListener: true
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        "aria-label": search,
        "data-testid": "".concat(search, "-iconButton"),
        buttonRef: function buttonRef(el) {
          return _this2.searchButton = el;
        },
        classes: {
          root: this.getActiveIcon(classes, 'search')
        },
        onClick: this.handleSearchIconClick
      }, /*#__PURE__*/_react.default.createElement(_Search.default, null))), options.legendTooltip && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          marginRight: options.origin === 'Studies' ? '20em' : '24em',
          fontSize: '16px',
          fontWeight: '600',
          color: '#000'
        }
      }, "Data Availability", /*#__PURE__*/_react.default.createElement(Tooltip, {
        title: (0, _util.generateDataAvailabilityTooltipText)(),
        interactive: true,
        classes: {
          tooltip: classes.dalTooltip,
          popper: classes.dalPopper,
          tooltipPlacementBottom: classes.dalTooltipBottom
        },
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        "aria-label": "help"
      }, /*#__PURE__*/_react.default.createElement("img", {
        style: {
          width: '0.7em',
          marginBottom: '0.6em'
        },
        src: "https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/icdc/images/svgs/Tooltip.SpeechBubble.svg",
        alt: "tooltip"
      })))), options.download && /*#__PURE__*/_react.default.createElement(Tooltip, {
        title: downloadCsv
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        "data-testid": "".concat(downloadCsv, "-iconButton"),
        "aria-label": downloadCsv,
        classes: {
          root: classes.icon
        },
        onClick: this.handleCSVDownload
      }, /*#__PURE__*/_react.default.createElement(_CloudDownload.default, null))), options.print && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_reactToPrint.default, {
        trigger: function trigger() {
          return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(Tooltip, {
            title: print
          }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
            "data-testid": "".concat(print, "-iconButton"),
            "aria-label": print,
            classes: {
              root: classes.icon
            }
          }, /*#__PURE__*/_react.default.createElement(_Print.default, null))));
        },
        content: function content() {
          return _this2.props.tableRef();
        }
      })), options.viewColumns && /*#__PURE__*/_react.default.createElement(_Popover.default, {
        refExit: this.setActiveIcon.bind(null),
        classes: {
          closeIcon: classes.filterCloseIcon
        },
        trigger: /*#__PURE__*/_react.default.createElement(Tooltip, {
          title: viewColumns,
          disableFocusListener: true
        }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          "data-testid": "".concat(viewColumns, "-iconButton"),
          "aria-label": viewColumns,
          classes: {
            root: this.getActiveIcon(classes, 'viewcolumns')
          },
          onClick: this.setActiveIcon.bind(null, 'viewcolumns')
        }, /*#__PURE__*/_react.default.createElement(_ViewColumn.default, null))),
        content: /*#__PURE__*/_react.default.createElement(_TableViewCol.default, {
          data: data,
          columns: columns,
          options: options,
          onColumnUpdate: toggleViewColumn
        })
      }), options.filter && /*#__PURE__*/_react.default.createElement(_Popover.default, {
        refExit: filterPopoverExit,
        hide: this.state.hideFilterPopover,
        classes: {
          paper: classes.filterPaper,
          closeIcon: classes.filterCloseIcon
        },
        trigger: /*#__PURE__*/_react.default.createElement(Tooltip, {
          title: filterTable,
          disableFocusListener: true
        }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          "data-testid": "".concat(filterTable, "-iconButton"),
          "aria-label": filterTable,
          classes: {
            root: this.getActiveIcon(classes, 'filter')
          },
          onClick: this.setActiveIcon.bind(null, 'filter')
        }, /*#__PURE__*/_react.default.createElement(_FilterList.default, null))),
        content: /*#__PURE__*/_react.default.createElement(_TableFilter.default, {
          customFooter: options.customFilterDialogFooter,
          columns: columns,
          options: options,
          filterList: filterList,
          filterData: filterData,
          onFilterUpdate: filterUpdate,
          onFilterReset: resetFilters,
          handleClose: closeFilterPopover,
          updateFilterByType: updateFilterByType
        })
      }), options.customToolbar && options.customToolbar()));
    }
  }]);
  return TableToolbar;
}(_react.default.Component);
var _default = (0, _styles.withStyles)(defaultToolbarStyles, {
  name: 'MUIDataTableToolbar'
})(TableToolbar);
exports.default = _default;